import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import ScribdDocumentView from 'js/liswp/ScribdDocumentView';

import { Visible } from 'javascripts/portfolio/components/visible';

class CV extends Component {
  render() {
    const { cv } = this.props;

    if (!cv || !cv.displayable) {
      return (
        <div style={{ textAlign: 'center' }}>
          Once you add a CV to your Academia.edu profile page, it will be
          automatically added here.
        </div>
      );
    }

    return (
      <div>
        <div>
          <ScribdDocumentView attachmentId={cv.id} />
        </div>

        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <Visible modes={(m) => m > 0}>
            <OverlayTrigger
              placement="top"
              overlay={
                <Tooltip id="cvPreviewTooltip">
                  {' '}
                  You are in preview mode. Once you register your website,
                  clicking 'Download' will download the CV.{' '}
                </Tooltip>
              }
            >
              <Button>Download</Button>
            </OverlayTrigger>
          </Visible>

          <Visible modes={0}>
            <Button href={cv.url} target="_blank" download>
              Download
            </Button>
          </Visible>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    cv: state.cv,
  };
};

export default connect(mapStateToProps)(CV);
